export default function parseJson(data: any) {
  if (!data || typeof data !== 'string') {
    return null
  }

  try {
    return JSON.parse(data)
  } catch (_error) {
    return null
  }
}
